<template>
  <div :class="['date-picker-container', options.class]">
    <label v-if="options.label"> {{options.label}} </label>
    <VueCtkDateTimePicker 
        v-model="selectedDates"
        id="datepicker"
        range
        no-label
        color="#128ff9"
        button-color="#128ff9"
        :no-value-to-custom-elem="true"

        :no-shortcuts="options.noShortcuts"
        :inline="options.inline"
        :min-date="options.minDate"
        :no-keyboard="options.noKeyboard"

        :auto-close="options.autoClose"
        :overlay="options.overlay"
        :noClearButton="options.noClearButton"
        :formatted="options.formatted"
        :format="options.format"
        :custom-shortcuts="options.customShortcuts"
        @input="runMethod(options.changeAction)">

        <div v-if="defaultRangeLabel" class="range-label">{{rangeLabel}}</div>
        
    </VueCtkDateTimePicker>

  </div>
</template>

<script>
  import moment from 'moment'
  import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
  import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

  export default {
    props: {
      defaultRangeLabel: String,
      options: Object,
      timeframe: Object,
    },
    name: 'DateRangePicker',

    components: {
      VueCtkDateTimePicker,
    },

    data() {
      return {
        dateRange: {
          start: null,
          end: null,
          prevStart: null,
          prevEnd: null,
        },
        prevRangeLabel: 'prev range',
        rangeLabel: null,
        selectedDates: null,
      }
    }, 

    methods: {
      runMethod(method) {
        const hasStartDate = !!this.selectedDates.start,
            hasEndDate = !!this.selectedDates.end,
            rangeSelected = hasStartDate && hasEndDate

        this[method](rangeSelected)
      },

      setTimeframe(rangeSelected) {
        let start, end, datesData
        if (rangeSelected) {
          start = moment(this.selectedDates.start).format('YYYY/MM/DD 00:00:00')
          end = moment(this.selectedDates.end).format('YYYY/MM/DD 23:59:59')
          datesData = { send_at_start: start, send_at_end: end }
        } else {
          datesData = { send_at_start: null, send_at_end: null }
        }
        this.$emit('updateTimeframe', datesData)
      },

      updateCurrentDates(rangeSelected) {
        if (rangeSelected) {
          this.dateRange.start = moment(this.selectedDates.start).utc().startOf('day').unix() 
          this.dateRange.end = moment(this.selectedDates.end).utc().endOf('day').unix()
          this.updatePrevRangeDates(this.selectedDates.shortcut)
          this.$nextTick(() => { this.updateRangeLabel() })
        }
      },

      updateData(field, value) {
        this.$emit('updateData', field, value)
      },

      updatePrevRangeDates(shortcut) {
        switch (shortcut) {
          case 'month':
            this.dateRange.prevStart = moment().utc().subtract(1, 'months').startOf('month').startOf('day').unix()
            this.dateRange.prevEnd = moment().utc().subtract(1, 'months').endOf('month').endOf('day').unix()
            break
          case '-month':
            this.dateRange.prevStart = moment().utc().subtract(2, 'months').startOf('month').startOf('day').unix()
            this.dateRange.prevEnd = moment().utc().subtract(2, 'months').endOf('month').endOf('day').unix()
            break
          default:
            let range_delta = (this.dateRange.end - this.dateRange.start) + 1
            this.dateRange.prevStart = this.dateRange.start - range_delta
            this.dateRange.prevEnd = this.dateRange.end - range_delta
        }
        this.updateData('dateRange', this.dateRange)
      },

      updatePrevRangeLabel(shortcutLabel) {
        const label = shortcutLabel && shortcutLabel.split(' ')[1],
            includesThis = shortcutLabel && shortcutLabel.includes('this'),
            includesLast = shortcutLabel && shortcutLabel.includes('last')
        if (shortcutLabel === 'today') {
          this.updateData('prevRangeLabel', 'yesterday')
        } else if (shortcutLabel === 'yesterday') {
          this.updateData('prevRangeLabel', 'prev day')
        } else if (includesThis) {
          this.updateData('prevRangeLabel', `last ${label}`)
        } else if (includesLast) {
          this.updateData('prevRangeLabel', `prev ${label}`)
        } else {
          this.updateData('prevRangeLabel', 'prev range')
        }
      },

      updateRangeLabel() {
        const hasSelectedShortcut = document.querySelector('.shortcuts-container .is-selected')
        let shortcutLabel = null
        if (hasSelectedShortcut) {
          shortcutLabel = document.querySelector('.shortcuts-container .is-selected .custom-button-content span').innerHTML.trim()
          this.rangeLabel = shortcutLabel
        } else {
          this.rangeLabel = `${moment(this.selectedDates.start).format('MM/DD/YYYY')} - ${moment(this.selectedDates.end).format('MM/DD/YYYY')}`
        }
        this.updatePrevRangeLabel(shortcutLabel)
      },
    },

    created() {
      this.timeframe ? this.selectedDates = this.timeframe : null
      this.rangeLabel = this.defaultRangeLabel
    },
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.date-picker-container
  margin: .5rem auto 2rem auto
  max-width: 200px

#datepicker-input
  text-align: center
  border: none
  color: $primary-color
  margin: 0
  height: auto
  min-height: 0

.range-label
  color: $primary-color
  cursor: pointer
  font-family: "AileronThin", Helvetica, Roboto, Arial, sans-serif
  text-align: center

.date-picker-container.inline
  display: flex
  flex-direction: column
  justify-content: center
  margin: 2rem auto
  max-width: 400px

  label
    margin: 0 auto 1rem auto

  .date-time-picker
    width: auto

.date-picker-container.inline
  
  #datepicker-wrapper
    border: 1px solid $primary-color

</style>